import {
    getAvailableDateRangesAPI,
    getAnalyticsDataLabelAPI,
    getLabelUsersForFilterAPI,
} from "./api"

export function getAvailableDateRanges(store) {
    return new Promise((resolve, reject) => {
        getAvailableDateRangesAPI(store).then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function getAnalyticsDataLabel(file, filter_user_id) {
    return new Promise((resolve, reject) => {
        getAnalyticsDataLabelAPI(file, filter_user_id).then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function getLabelUsersForFilter() {
    return new Promise((resolve, reject) => {
        getLabelUsersForFilterAPI().then((res) => resolve(res)).catch(err => reject(err))
    })
}
